<template>
  <div>
    <el-dialog
        class="pending-product-dialog"
        :mode="mode"
        :disable-save-button="disableSaveButton"
        :visible.sync="dialogVisible"
        :append-to-body="appendToBody"
        :width="width"
        :before-close="beforeClose"
        :show-close="showClose"
        :close-on-click-modal="closeOnClickModal"
        @open="onOpen"
        @opened="onOpened"
        @close="onClose"
        @closed="onClosed">
      <span slot="title">
        <slot name="title">
          <span class="title">{{ title }}</span>
        </slot>
      </span>
      <slot name="contents" />
      <span
          v-if="showFooter"
          slot="footer">
        <span class="prepend-footer">
          <slot name="prependFooter" />
        </span>
        <template>
          <el-button
              v-if="mode === define.PENDING_PRODUCT_MODE.NORMAL && $isFunctionShown(define.PermissionKeys.PendingProduct.List.EDIT)"
              :disabled="$isFunctionDisabled(define.PermissionKeys.PendingProduct.List.EDIT)"
              @click="onEditButtonClick">
            編集
          </el-button>
          <el-button
              v-if="mode === define.PENDING_PRODUCT_MODE.NORMAL && $isFunctionShown(define.PermissionKeys.PendingProduct.List.DELETE)"
              :disabled="$isFunctionDisabled(define.PermissionKeys.PendingProduct.List.DELETE)"
              @click="onDeleteButtonClick">
            削除
          </el-button>
          <el-button
              v-if="mode === define.PENDING_PRODUCT_MODE.NORMAL"
              @click="onCloseButtonClick">
            閉じる
          </el-button>
          <el-button
              v-if="mode === define.PENDING_PRODUCT_MODE.NEW || mode === define.PENDING_PRODUCT_MODE.EDIT"
              :disabled="disableSaveButton"
              @click="onRegistButtonClick">
            保存
          </el-button>
          <el-button
              v-if="mode === define.PENDING_PRODUCT_MODE.NEW || mode === define.PENDING_PRODUCT_MODE.EDIT"
              @click="onCancelButtonClick">
            キャンセル
          </el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.title {
    font-size: 16px;
    font-weight: bold;
    color: #181d62;
}
.prepend-footer {
  float: left;
}
.pending-product-dialog ::v-deep .el-dialog {
  margin: 15vw;
}
.pending-product-dialog  ::v-deep .delBtn button {
  padding: 3px 3px;
  border: none;
  background-color: white;
  font-size: 12pt;
}
.pending-product-dialog  ::v-deep .addBtn button {
  padding: 3px 3px;
  border: none;
  background-color: white;
  font-size: 12pt;
}
.pending-product-dialog ::v-deep .delBtn button {
  color: rgb(226, 41, 8);
}
.pending-product-dialog ::v-deep .addBtn button {
  color: rgb(46, 122, 36);
}
.pending-product-dialog ::v-deep .flex :first-child {
  flex-grow: 1;
  max-width: 200px;
}
</style>

<script>
import * as define from '@/define'

export default {
  name: 'PendingProductBaseDialog',
  inject: ['parentValidator'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: null
    },
    beforeClose: {
      type: Function,
      default: null
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showOnlyCloseButton: {
      type: Boolean,
      default: true
    },
    disableOkButton: {
      type: Boolean,
      default: false
    },
    disableSaveButton: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mode: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogVisible: false,
      closed: false,
      closeOnClickModal: true
    }
  },
  computed: {
    define: () => define
  },
  watch: {
    visible (val) {
      if (val) {
        this.dialogVisible = true
        this.closed = false
      } else {
        this.dialogVisible = false
        this.closed = true
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    onOpen () {
      this.$emit('open')
    },
    onOpened () {
      this.$emit('opened')
    },
    onClose () {
      if (this.closed) {
        return
      }
      this.$emit('update:visible', false)
      this.dialogVisible = false
      this.$emit('close')
      this.closed = true
    },
    onClosed () {
      this.$emit('closed')
    },
    onCloseButtonClick () {
      if (this.beforeClose != null) {
        this.beforeClose(this.onClose)
      } else {
        this.onClose()
      }
    },
    onRegistButtonClick () {
      this.$emit('regist')
    },
    onCancelButtonClick () {
      this.$emit('cancel')
    },
    onOkButtonClick () {
      this.$emit('ok')
    },
    onEditButtonClick () {
      this.$emit('edit')
    },
    onDeleteButtonClick () {
      this.$emit('delete')
    }
  }
}
</script>
